import { Component, HostBinding, input, output } from '@angular/core';

import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-button',
  imports: [MatTooltip],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
/**
 * Die 'ButtonComponent'-Klasse definiert einen Button.
 * BEGRÜNDUNG: Es gibt keine AFO die das Nutzen von Buttons
 * für den TI-Messenger vorschreibt.
 */
export class ButtonComponent {
  text = input<string>();
  isPrimary = input<boolean>(false);
  isDisabled = input<boolean>(false);
  type = input<'button' | 'submit'>('button');
  dataTestId = input<string>();
  tooltip = input<string>();
  tooltipPosition = input<'left' | 'right' | 'above' | 'below' | 'before' | 'after'>('below');
  customWidth = input<string>();
  clicked = output<MouseEvent>();
  collapsed = input<boolean>();

  @HostBinding('attr.disabled') get isButtonDisabled(): true | null {
    return this.isDisabled() ? true : null;
  }
}
